<template>
  <div>
    <div class="field">
      <div class="name">
        <span class="flag">*</span>
        <span class="b-title">所在城市</span>
        <span class="warn" v-if="!regCity">此处不能为空</span>
      </div>
      <div class="city-input">
        <div class="each-city-input">
          <div class="input-name">国家：</div>
          <i-select
          v-model="country"
          @on-change="getProvince">
            <i-option v-for="item in countrys" :value="item.id" :key="item.id">{{ item.name }}</i-option>
          </i-select>
        </div>
        <div class="each-city-input" v-if="provinces.length">
          <div class="input-name">省份：</div>
          <i-select
          v-model="province"
          @on-change="getCity">
            <i-option v-for="item in provinces" :value="item.id" :key="item.id">{{ item.name }}</i-option>
          </i-select>
        </div>
        <div class="each-city-input">
          <div class="input-name">城市：</div>
          <i-select
          v-model="city"
          @on-change="exportCity">
            <i-option v-for="item in citys" :value="item.id" :key="item.id">{{ item.name }}</i-option>
          </i-select>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import areaData from '@/config/areaData'
import Select from '@/components/form/iview/components/select'
import Option from '@/components/form/iview/components/option'

export default {
  data () {
    return {
      areaData,
      countrys: [
        { id: 1, name: '中国' },
        { id: 2, name: '美国' },
        { id: 3, name: '新加坡' }
      ],
      provinces: [],
      citys: [],
      // 默认展示中国
      country: 1,
      province: '',
      city: ''
      // selectedValue: {}
    }
  },
  components: {
    iSelect: Select,
    iOption: Option
  },
  props: ['regCity'],
  mounted () {
    this.getProvince(this.country)
  },
  methods: {
    getProvince (value) {
      this.$emit('setRegCity', true)
      if (value === 1) {
        this.$emit('exportValue', { key: 'country', value: 1 })
        this.provinces = this.areaData['86'].filter(item => item.cid === 1)
        this.province = ''
        this.city = ''
        this.$emit('exportValue', { key: 'province', value: '' })
        this.$emit('exportValue', { key: 'city', value: '' })
      } else if (value === 2 || value === 3) {
        this.$emit('exportValue', { key: 'country', value })
        this.$emit('exportValue', { key: 'province', value: 0 })
        this.citys = this.areaData[value === 2 ? '9999' : '9998'].childs
        this.provinces = []
        this.city = ''
        this.$emit('exportValue', { key: 'city', value: '' })
      }
    },
    getCity (value) {
      this.$emit('setRegCity', true)
      this.citys = []
      this.city = ''
      this.$emit('exportValue', { key: 'province', value: value })
      // this.selectedValue['province'] = value
      if (this.areaData[value].childs) {
        this.citys = this.areaData[value].childs
      }
    },
    exportCity (value) {
      this.$emit('setRegCity', true)
      this.$emit('exportValue', { key: 'city', value: String(value) === 'undefined' ? '' : value })
      // this.selectedValue['city'] = obj.value
      // this.$emit('input', this.selectedValue)
    }
  }
}
</script>
<style scoped lang='sass'>
@import '../../../../style/bulma/app.sass'

$primary: #D7B375

.field
  margin-bottom: 18px
  .name
    margin-bottom: 8px
    display: flex
    align-items: center
    transition: all 1s linear
    .b-title
      margin-right: 15px
    .flag
      color: $primary
      font-size: 24px
      margin-right: 5px
    .warn
      font-size: 14px
      color: $primary
  .city-input
    margin-left: 48px
    display: flex
    +mobile
      margin-left: 0
      display: block
    .each-city-input
      display: flex
      align-items: center
      width: 33.333%
      margin-right: 20px
      +mobile
        margin-right: 0
        width: 100%
        margin-bottom: 12px
      .input-name
        width: 70px
        word-break: keep-all
      &:last-child
        margin-right: 0
      .tgo-select
        flex-grow: 1
</style>
